import React from 'react';

import { AiOutlineApi, AiOutlineTeam } from 'react-icons/ai';
import { FiCheckCircle, FiGrid } from 'react-icons/fi';
import { IoIosCloudOutline } from 'react-icons/io';
import { RiKey2Line, RiUserSettingsLine } from 'react-icons/ri';

import { featureFlags } from 'app/flagsmith/features';
import {
  GroupIcon,
  PermissionsActionsIcon,
  VulnerabilityIcon,
} from 'components/Icons';

export const routeConfig = {
  '/': {
    noBreadcrumb: true,
    navBar: {
      base: '/',
      list: [
        {
          url: '/',
          title: 'Overview',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/dashboard/infrastructure',
          title: 'Infrastructure',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/dashboard/vulnerability',
          title: 'Vulnerabilities',
          exact: true,
          icon: <VulnerabilityIcon />,
        },
        {
          url: '/dashboard/data',
          title: 'Data',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/dashboard/identity',
          title: 'Identity',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
      ],
    },
  },
  '/dashboard': {
    noBreadcrumb: true,
    navBar: {
      base: '/dashboard',
      list: [
        {
          url: '',
          title: 'Overview',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/infrastructure',
          title: 'Infrastructure',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/vulnerability',
          title: 'Vulnerabilities',
          exact: true,
          icon: <VulnerabilityIcon />,
        },
        {
          url: '/data',
          title: 'Data',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/identity',
          title: 'Identity',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
      ],
    },
  },
  '/findings': {
    noBreadcrumb: true,
    navBar: {
      base: '/findings',
      list: [
        {
          url: '/overview',
          title: 'Overview',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/alerts',
          title: 'Issues',
          exact: true,
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/tickets',
          title: 'Tickets',
          exact: true,
          //icon: <TicketIcon />,
        },
      ],
    },
  },
  '/inventory': {
    noBreadcrumb: true,
    navBar: {
      base: '/inventory',
      list: [
        {
          url: '/cloud',
          title: 'Cloud',
          //exact: true,
          //icon: <IoIosCloudOutline />,
        },
        {
          url: '/software',
          title: 'Software',
          featureFlag: featureFlags.inventoryV3,
        },
        {
          url: '/allowlist',
          title: 'Allow List',
          //icon: <IoIosCloudOutline />,
        },
        {
          url: '/context',
          title: 'Context',
          //icon: <IoIosCloudOutline />,
        },
      ],
    },
  },
  '/reports': {
    noBreadcrumb: true,
    navBar: {
      base: '/reports',
      list: [
        {
          url: '/dashboard',
          title: 'Dashboard',
          //exact: true,
          //icon: <IoIosCloudOutline />,
        },
        {
          url: '/all',
          title: 'Reports',
          //icon: <IoIosCloudOutline />,
        },
      ],
    },
  },
  '/policy-hub': {
    navBar: {
      base: '/policy-hub',
      list: [
        {
          url: '/blueprint',
          title: 'Blueprint',
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/policy/cloud',
          title: 'Cloud Policies',
          icon: <IoIosCloudOutline />,
          badgeLeft: '34px',
        },
        {
          url: '/remediation',
          title: 'Remediation',
          //icon: <RemediateIcon />,
          badgeLeft: '75px',
        },
        {
          url: '/workflow',
          title: 'Workflow',
          //icon: <AlertWorkflowIcon />,
        },
      ],
    },
  },
  '/setup': {
    navBar: {
      base: '/setup',
      list: [
        {
          url: '/accounts',
          title: 'Accounts',
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/outpost',
          title: 'Outpost',
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/environment',
          title: 'Environment',
          //icon: <EnvironmentIcon />,
        },
        {
          url: '/data',
          title: 'Data',
          //icon: <DataClassificationIcon />,
        },
        {
          url: '/roles',
          title: 'Roles',
          icon: <RiUserSettingsLine />,
        },
        {
          url: '/groups',
          title: 'Groups',
          icon: <GroupIcon />,
        },
        {
          url: '/users',
          title: 'Users',
          icon: <AiOutlineTeam />,
        },
        {
          url: '/ip-whitelisting',
          title: 'IP Whitelisting',
          icon: <FiCheckCircle />,
        },
        {
          url: '/integrations',
          title: 'Integrations',
          icon: <AiOutlineApi />,
        },
        {
          url: '/api-keys',
          title: 'API Keys',
          icon: <RiKey2Line />,
        },
      ],
    },
  },
  '/jit': {
    navBar: {
      base: '/jit',
      list: [
        {
          url: '/data/catalog',
          title: 'Data Catalog',
          icon: <FiGrid />,
        },
        {
          url: '/requests',
          title: 'Requests',
          icon: <PermissionsActionsIcon />,
        },
        {
          url: '/data/group',
          title: 'Data Groups',
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/data/policy',
          title: 'Masking Policies',
          icon: <IoIosCloudOutline />,
        },
        {
          url: '/setup',
          title: 'Setup',
          icon: <IoIosCloudOutline />,
        },
      ],
    },
  },
  '/visibility': {
    navBar: {
      base: '/visibility',
      list: [
        {
          url: '/security-graph',
          title: 'Security Graph',
          icon: <AiOutlineTeam />,
        },
        {
          url: '/vulnerability',
          title: 'Vulnerabilities',
          icon: <VulnerabilityIcon />,
        },
        {
          url: '/data',
          title: 'Data',
          icon: <AiOutlineTeam />,
        },
        {
          url: '/activity',
          title: 'Activity',
          icon: <AiOutlineTeam />,
        },
        {
          url: '/security-graph-next',
          title: 'Security Graph Next',
          icon: <AiOutlineTeam />,
        },
      ],
    },
  },
};
